export class Ajax {
	static GET(url, type = 'json') {
		return new Promise((resolve, reject) => {
			const request = new XMLHttpRequest();
			request.open('GET', url, true);

			request.onload = () => {
				let responseData = request.responseText;
				let status = request.status;

				if (status === 200 && responseData) {
					if (type === 'json') {
						responseData = JSON.parse(responseData);
					}

					resolve(responseData);
				} else {
					reject(status + ' error');
				}
			};

			request.onerror = () => {
				reject('error');
			};
			request.onabort = () => {
				reject('aborted');
			};

			request.send();
		});

	}

	static POST(url, type = 'json', params = '') {
		return new Promise((resolve, reject) => {
			const request = new XMLHttpRequest();
			request.open('POST', url, true);
			request.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
			request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

			request.onload = () => {
				let status = request.status;
				let responseData = request.responseText;

				if (status === 200 && responseData) {
					if (type === 'json') {
						responseData = JSON.parse(responseData);
					}

					resolve(responseData);
				} else {
					reject(responseData);
				}
			};

			request.onerror = () => {
				reject('error');
			};
			request.onabort = () => {
				reject('aborted');
			};

			request.send(params);
		});
	}
}

